// Inline "From library" picker (never a popup): the user's library files for this training, searchable.
// Images use RefGrid (tiles + 🔍 corner preview); videos are plain thumbnail tiles. onPick({ url, name }).

import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { LuSearch } from "react-icons/lu";
import { fetchIdealStudioFiles } from "../../../../../common/server_utils.es6";
import VideoThumb from "../../../timeline/IdeaTimeline/components/VideoThumb";
import { RefGrid } from "./FrameSlot";

const t = (key, opts) => i18n.t(`FileModal.APIProviders.VideoGeneration.Director.${key}`, opts);

// Same db types as MyFilesPanel's Video filter (generated and uploaded clips).
const VIDEO_TYPES = ["video", "video/mp4", "video/webm", "video/mov", "course-video", "video/quicktime"];

export default function LibraryPicker({ kind = "image", onPick }) {
  const [search, setSearch] = useState("");
  const [files, setFiles] = useState(undefined); // undefined = loading
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    setFiles(undefined);
    setFailed(false);
    const timer = setTimeout(() => {
      fetchIdealStudioFiles({
        search: search || undefined,
        limit: 50,
        offset: 0,
        fileType: kind === "video" ? VIDEO_TYPES : "image",
      })
        .then((res) => {
          if (!alive) return;
          setFiles(
            (res?.files || [])
              .filter((f) => f.fileVirtualPath)
              .map((f) => ({
                id: f.id,
                url: (kind === "video" && f.metadata?.mp4Url) || f.fileVirtualPath,
                name: f.fileName || f.filename || t("Untitled"),
              }))
          );
        })
        .catch(() => alive && (setFailed(true), setFiles([])));
    }, 250);
    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [search, kind]);

  return (
    <div className="add-video-modal__lib-picker">
      <label className="add-video-modal__lib-search">
        <LuSearch size={14} aria-hidden="true" />
        <input
          type="search"
          aria-label={t("LibrarySearch")}
          placeholder={t("LibrarySearch")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </label>
      {files === undefined && <div style={{ fontSize: 12, color: "#64748b" }}>{t("Loading")}</div>}
      {failed && <div role="alert" style={{ fontSize: 12, color: "#ef4444" }}>{t("LibraryLoadFailed")}</div>}
      {files && !failed && kind === "image" && (
        <RefGrid
          entries={files.map((f) => ({
            key: `f${f.id}`,
            item: { status: "ready", url: f.url },
            label: f.name,
            file: f,
          }))}
          isOn={() => false}
          onPick={(e) => onPick(e.file)}
        />
      )}
      {files && !failed && kind === "video" &&
        (files.length === 0 ? (
          <div style={{ fontSize: 12, color: "#64748b" }}>{t("NothingHere")}</div>
        ) : (
          <div className="add-video-modal__fs-grid">
            {files.map((f) => (
              <button
                key={f.id}
                type="button"
                aria-label={f.name}
                title={f.name}
                className="add-video-modal__director-ref add-video-modal__director-ref--pick"
                onClick={() => onPick(f)}
              >
                <div className="add-video-modal__director-ref-img">
                  <VideoThumb url={f.url} seekSec={0.5} className="add-video-modal__director-clip-thumb" />
                </div>
              </button>
            ))}
          </div>
        ))}
    </div>
  );
}
